import React from 'react';

export const SquaredOffBar = ({pct, color, label, labelColor}) => {
  return (
    <div className="bar-wrap">
      <div className="bar-background">
        <div className="bar-active" style={{width: `${pct}%`, backgroundColor: color}} />
        <div className="bar-label" style={{color: labelColor}}>
          {label}
        </div>
      </div>
    </div>
  );
};
